var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5L22.5 22.5M22.5 17.5L17.5 22.5",
    stroke: "#C10000",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6664 5H30C30.442 5 30.8658 5.17557 31.1783 5.48808C31.4909 5.80059 31.6664 6.22444 31.6664 6.6664V33.3336C31.6664 33.7756 31.4909 34.1994 31.1783 34.5119C30.8658 34.8244 30.442 35 30 35H10C9.55806 35 9.13421 34.8244 8.8217 34.5119C8.50919 34.1994 8.33362 33.7756 8.33362 33.3336V8.3336M11.6664 5L8.33362 8.3336M11.6664 5V8.3336H8.33362",
    stroke: "#C10000",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesCancel);
export default __webpack_public_path__ + "static/media/NotesCancel.c970c65eed92fad38e18dc305b72f385.svg";
export { ForwardRef as ReactComponent };